import { DatasPossiveis, Formatacoes } from "./Formatacao";

type Resultado = -1 | 0 | 1;

export class Ordenar {
    static Booleano: (a?: boolean, b?: boolean) => Resultado = (a, b) => a == b ? 0 : a ? 1 : -1;
    static String: (a?: string, b?: string) => Resultado = (a, b) => a == b ? 0 : !a ? 1 : !b ? -1 : a.localeCompare(b) as Resultado;
    static Numero: (a?: number, b?: number) => Resultado = (a, b) => a == b ? 0 : !a ? 1 : !b ? -1 : a > b ? 1 : -1;

    static Data: (a?: DatasPossiveis, b?: DatasPossiveis) => Resultado = (a, b) => { 
        a = Formatacoes.paraData(a); b = Formatacoes.paraData(b); return a == b ? 0 : !a ? 1 : !b ? -1 : a > b ? 1 : -1
    };
}

export default Ordenar;